import type { BackendEntitiesFromBackend } from '../types';

import { URL } from '../../../constants';
import { ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';
import { createSearchParams } from './create-search-params';
import type { PrematchContentPayload } from './type';

// ---

export const getPrematchContent = (config: ServiceConfig, payload: PrematchContentPayload) => {
  type AdapterProps = { response: BackendEntitiesFromBackend['diff'] };

  const searchParams = createSearchParams(payload.query);
  const url = searchParams.toString() ? `${URL.PREMATCH_CONTENT}?${searchParams.toString()}` : URL.PREMATCH_CONTENT;

  return defaultRequestService<AdapterProps>(url, config.instance.get);
};
